var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filters"},[_c('FormGroup',{attrs:{"label":_vm.$t('planification.filters.group-name.label')}},[_c('Input',{model:{value:(_vm.groupName),callback:function ($$v) {_vm.groupName=$$v},expression:"groupName"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }